// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetProjectIterationLookupRequestModel from '../../model/get-project-iteration-lookup-request-model';
import GetProjectIterationLookupRequestDTO from '../dto/get-project-iteration-lookup-request-dto';
import dtoSchema from '../schemas/get-project-iteration-lookup-request-schema';

export default abstract class GetProjectIterationLookupRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetProjectIterationLookupRequestDTO>) {
    super();
    if (data) {
      this.projectId = data.projectId;
    }
  }
  /**
  * @type {uuid}
  */
  projectId?: string;

  static toModel(dto: DeepPartial<GetProjectIterationLookupRequestDTO>): GetProjectIterationLookupRequestModel;
  static toModel(dto: DeepPartial<GetProjectIterationLookupRequestDTO> | undefined | null): GetProjectIterationLookupRequestModel | undefined;
  static toModel(dto: DeepPartial<GetProjectIterationLookupRequestDTO> | undefined | null): GetProjectIterationLookupRequestModel | undefined {
    return dto ? new GetProjectIterationLookupRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetProjectIterationLookupRequestModel> | GetProjectIterationLookupRequestModel): GetProjectIterationLookupRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      projectId: unwrapped.projectId,
    } as GetProjectIterationLookupRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetProjectIterationLookupRequestModel, can not map to GetProjectIterationLookupRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
